var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThumbsUpFilled = function SvgThumbsUpFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.49 24.32a3.75 3.75 0 0 1-3.707 3.18H5A2.5 2.5 0 0 1 2.5 25v-8.75a2.5 2.5 0 0 1 2.5-2.5h2.938c.494 0 .941-.29 1.142-.742l4.399-9.898c.165-.37.533-.61.939-.61A3.08 3.08 0 0 1 17.5 5.582V10c0 .69.56 1.25 1.25 1.25h4.379a3.75 3.75 0 0 1 3.706 4.32z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#A1A1A1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M8.75 27.5V13.75m-6.25 2.5V25A2.5 2.5 0 0 0 5 27.5h16.783a3.75 3.75 0 0 0 3.706-3.18l1.346-8.75a3.75 3.75 0 0 0-3.706-4.32H18.75c-.69 0-1.25-.56-1.25-1.25V5.582A3.08 3.08 0 0 0 14.418 2.5c-.406 0-.774.24-.94.61L9.08 13.008a1.25 1.25 0 0 1-1.142.742H5a2.5 2.5 0 0 0-2.5 2.5"
  })));
};
export default SvgThumbsUpFilled;